/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Characters(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5008 6.50098C13.8787 6.50098 15.1523 7.15084 16.3114 8.2373L16.5418 8.46094L16.6102 8.53711C16.9302 8.92982 16.9077 9.50899 16.5418 9.875C16.1756 10.241 15.5957 10.2639 15.203 9.94336L15.1278 9.875L14.9413 9.69434C14.3665 9.15543 13.8353 8.82591 13.3465 8.65332L12.6678 13.4062V17.501C12.6676 18.0531 12.22 18.501 11.6678 18.501C11.1156 18.501 10.668 18.0531 10.6678 17.501V14.335H9.33481V17.501C9.33463 18.053 8.88683 18.5008 8.33481 18.501C7.78263 18.501 7.33498 18.0531 7.33481 17.501V13.4062L6.65512 8.65332C6.11409 8.84447 5.52149 9.22836 4.87485 9.875C4.48436 10.2653 3.85127 10.2653 3.46078 9.875C3.07031 9.48453 3.07042 8.85147 3.46078 8.46094C4.6808 7.24092 6.03108 6.50109 7.50082 6.50098H12.5008ZM9.20102 12.335H10.8006L11.3485 8.50098H8.65414L9.20102 12.335ZM10.0008 0.667969C10.7081 0.667971 11.3865 0.949124 11.8866 1.44922C12.3866 1.9493 12.6678 2.6278 12.6678 3.33496C12.6676 4.04197 12.3865 4.72076 11.8866 5.2207C11.3865 5.7205 10.7078 6.00097 10.0008 6.00098C9.29377 6.00089 8.61508 5.72062 8.11508 5.2207C7.61514 4.72076 7.33498 4.04197 7.33481 3.33496C7.33481 2.62794 7.61529 1.94927 8.11508 1.44922C8.6151 0.949198 9.29369 0.668055 10.0008 0.667969ZM10.0008 2.66797C9.8242 2.66805 9.65505 2.73844 9.53012 2.86328C9.40519 2.98829 9.33481 3.15823 9.33481 3.33496C9.33498 3.51154 9.40525 3.68079 9.53012 3.80566C9.65505 3.93051 9.82421 4.00089 10.0008 4.00098C10.1776 4.00097 10.3475 3.93059 10.4725 3.80566C10.5973 3.68081 10.6676 3.51146 10.6678 3.33496C10.6678 3.15823 10.5974 2.98829 10.4725 2.86328C10.3475 2.73826 10.1776 2.66797 10.0008 2.66797Z"
        fill="#35424F"
      />
    </svg>
  )
}

Characters.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Characters
